import {
  isDocxUploadPath,
  isImageUploadPath,
  isLegacyDocUploadPath,
  isPdfUploadPath
} from './uploadUrl';

export async function readBlobHead(blob, length = 16) {
  if (!blob) return new Uint8Array();
  const buf = await blob.slice(0, length).arrayBuffer();
  return new Uint8Array(buf);
}

export function isOleCompoundDocument(bytes) {
  return bytes?.length >= 4
    && bytes[0] === 0xD0
    && bytes[1] === 0xCF
    && bytes[2] === 0x11
    && bytes[3] === 0xE0;
}

function isExcelFileName(fileName = '') {
  return /\.(xlsx|xlsm|xls)$/i.test(String(fileName).replace(/[?#].*$/, ''));
}

export function sniffPreviewKindFromBytes(bytes, fileName = '') {
  if (!bytes?.length) {
    return sniffPreviewKindFromName(fileName);
  }

  const sig4 = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]);
  const sig3 = String.fromCharCode(bytes[0], bytes[1], bytes[2]);

  if (sig4 === '%PDF') return 'pdf';
  if (sig4 === 'PK\u0003\u0004') {
    return isExcelFileName(fileName) ? 'excel' : 'docx';
  }
  if (isOleCompoundDocument(bytes)) {
    if (isExcelFileName(fileName)) return 'excel';
    return isDocxUploadPath(fileName) ? 'legacy-docx-disguised' : 'legacy-doc';
  }
  if (bytes[0] === 0xFF && bytes[1] === 0xD8) return 'image';
  if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) return 'image';
  if (sig3 === 'GIF') return 'image';
  if (sig4.startsWith('<!D') || sig3.toLowerCase() === 'htm') return 'unknown';

  return sniffPreviewKindFromName(fileName);
}

export function sniffPreviewKindFromName(fileName = '') {
  if (isExcelFileName(fileName)) return 'excel';
  if (isPdfUploadPath(fileName)) return 'pdf';
  if (isImageUploadPath(fileName)) return 'image';
  if (isDocxUploadPath(fileName)) return 'docx';
  if (isLegacyDocUploadPath(fileName)) return 'legacy-doc';
  return 'unknown';
}

export function friendlyDocxPreviewError(error) {
  const message = String(error?.message || error || '');
  if (message.includes('zip') || message.includes('central directory')) {
    return '文件不是有效的 Word 文档（可能为 PDF/图片扫描件但扩展名为 .docx），请下载查看或重新上传 PDF/图片格式';
  }
  return message || 'Word 预览失败';
}
